// 底部公共

import { useState, useEffect } from 'react'
import { message, Form, Input, Button, Modal, Carousel, Dropdown, Drawer } from 'antd'
import fun from '../../common/common_fun'
import url from '../../common/url_config'
import { UserOutlined, LockOutlined, UnorderedListOutlined } from '@ant-design/icons';
import cookie from 'react-cookies'


let main_width_style: any = { width: '94%', margin: '0 auto', maxWidth: 1300 }

function App(props: any) {
  let [current_language_ch, set_current_language_ch] = useState(window.location.href.indexOf('?lan=en') === -1)//当前语言是否中文

  let linker_set = [
    {
      name_ch: '恩智浦官网',
      name_en: 'NXP.COM',
      href_ch: 'https://www.nxp.com.cn/',
      href_en: 'https://www.nxp.com/'
    },
    {
      name_ch: '隐私政策',
      name_en: 'Privacy',
      href_ch: 'https://www.nxp.com.cn/pages/privacy-statement:PRIVACYPRACTICES',
      href_en: 'https://www.nxp.com/pages/privacy-statement:PRIVACYPRACTICES'
    },
    {
      name_ch: '使用条款',
      name_en: 'Terms of Use',
      href_ch: 'https://www.nxp.com.cn/pages/terms-of-use:TERMSOFUSE',
      href_en: 'https://www.nxp.com/pages/terms-of-use:TERMSOFUSE'
    },
  ]

  useEffect(() => {
  }, [])

  return (
    <div className='main_index_show' style={{
      paddingTop: 30, paddingBottom: 30, backgroundColor: '#ffffff', borderTop: '1px solid #b3b3b3',
    }}>
      <div className='footer_linker_box' style={{ ...main_width_style, overflow: 'hidden', justifyContent: 'space-between', color: '#64798a', alignItems: 'center' }}>
        <div style={{ display: 'flex', lineHeight: '18px', height: 18 }}>
          {linker_set.map((item: any, index: number) => <a style={index === 0 ? {} : { marginLeft: 5, paddingLeft: 5, borderLeft: '1px solid #64798a' }} target={'_blank'} href={current_language_ch ? item.href_ch : item.href_en} key={index}><span>{current_language_ch ? item.name_ch : item.name_en}</span></a>)}
        </div>
        <div>
          <span style={{ display: 'flex', alignItems: 'center' }}  >
            <img style={{ marginRight: 5 }} src="https://www.nxp.com.cn/assets/images/en/logos-external/national-internet-security-management-service-platform-logo.png" alt="national internet security management service platform logo" width="20" />沪公网安备31010602004586号
            <a style={{ marginLeft: 5, paddingLeft: 5, borderLeft: '1px solid #64798a' }} href="https://beian.miit.gov.cn" target="_blank">沪ICP备18047220号</a>
          </span>
        </div>
        <div>©2006-2024 NXP Semiconductors. All rights reserved.</div>
      </div>
    </div>
  )
}

export default App